<template>
  <div class="contractManagement-addLeaseColumn-dialog">
    <custom-dialog
      width="1400px"
      :title="model.title"
      :visible="visible"
      v-on="$listeners"
    >
      <div class="dialog-body">
        <!-- 表格 -->
        <div class="product-wrap">
          <el-form :inline="true" label-position="top">
              <el-form-item :label="$t('crm_contractManagement_addLeaseColumn_dialog.chan_pin_xing_hao')">
                <custom-select
                  v-model="formSearch.productCode"
                  url="productCodeSelectList"
                   :props="{ label: 'productName', value: 'productCode' }"
                  :placeholder="$t('Common.com_please_select')"
                  width="100%"
                  @change="getLessee"
                ></custom-select>
              </el-form-item>
            </el-form>
          <div class="table-bd">
            <custom-table
              type="checkbox"
              v-model="tableSelect"
              v-loading="isLoading"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
              :defaultExpandAll="true"
              row-key="keyId"
              selectableKey="categoryId"
              :column="tableColumn"
              :data="rentLsseeList"
              height="500px"
            >
            </custom-table>
          </div>
          <div class="table-page">
            <custom-page
              :total="totalRows"
              :page="formSearch.pageNum"
              :size="formSearch.pageSize"
              @change="onPageChange"
            ></custom-page>
          </div>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{
          $t('Common.com_cancel')
        }}</el-button>
        <el-button type="primary" @click="saveChoose">{{
          $t('Common.com_confirm')
        }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'contract_choose_sku',
      rentLsseeList: [],
      isLoading: false,
      formSearch: {
        productCode: undefined,
        deviceBizType: undefined, // 设备业务类型，字典分组代码：dms_device_biz_type
        rentalTermUnit: undefined, // 租赁单位，字典分组代码：rental_term_unit
        rentalTerms: undefined, // 租赁月/周/日数
        paymentPeriod: undefined, // 支付周期，字典分组代码：crm_payment_period
        paymentNode: undefined, // 付款时间节点，字典分组代码：payment_node
        pageSize: 50,
        pageNum: 1,
        bigCustomerId: ''// 乙方customerId
      },
      totalRows: null,
      leaseListSelect: [],
    };
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.initDialog();
    this.getLessee();
    this.getTableColumn();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.formSearch.bigCustomerId = this.model.bigCustomerId;
      // this.formSearch.currencyUnit = this.data.currencyUnit;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取关联列表
    getLessee: function () {
      this.$getJSON(apis.rmsGoodsSelectList, this.formSearch).then((res) => {
        const data = res.data.list;
        // data.forEach((i) => {
        //   i.children = i.childrenList;
        // });
        this.rentLsseeList = data;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getLessee();
    },
    // 表格选中变更
    // selectionChange: function (val, name) {
    //   if (val.length > 1) {
    //     this.$refs.table.$refs.tb1.clearSelection();
    //     const select = val.pop();
    //     this.$refs.table.$refs.tb1.toggleRowSelection(select);
    //     this[name] = [select];
    //     // this.name = [];
    //     // this[name] = val;
    //   } else {
    //     // this.name = [];
    //     this[name] = val;
    //   }
    //   // this.setTopicCode();
    // },

    clear: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.getLessee();
    },

    // 切换页
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      this.getLessee();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getLessee();
    },
    // 保存新增
    saveChoose: function () {
      if (!this.tableSelect.length) {
        this.$message({
          message: this.$t('crm_contractManagement_addLeaseColumn_dialog.qing_xuan_ze_fang_an'),
          type: 'error',
        });
      } else {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success', this.tableSelect);
        this.closeDialog();
      }
    },
  },
};
</script>

<style lang="scss">
.contractManagement-addLeaseColumn-dialog {
  .search-container {
    padding: 0px 8px 8px;
    margin-bottom: 16px;
    background: #f6f6fa;
    border-radius: 2px;
    overflow: hidden;
    // overflow: hidden;
    .el-form-item {
      // width: 14.2%;
      width: 16.6%;
      margin: 0 !important;
      margin-bottom: 0px !important;
      padding: 0 8px;
      .el-input__inner {
        border: none !important;
      }
    }
    > .advanced-footer {
      overflow: hidden;
      margin-top: 10px;
      .button-group {
        margin-right: 8px;
        margin-bottom: 8px;
        margin-top: 8px;
        float: right;
      }
    }
    .el-input-group__prepend {
      background-color: #ffffff;
      border: none;
      .el-select {
        vertical-align: baseline !important;
      }
    }

    .el-input.is-disabled .el-input__inner {
      background-color: #fcfcfc;
    }

    .el-form-item--small .el-form-item__label {
      margin-top: 16px;
      font-size: 12px;
      padding: 0px 0px 4px 0 !important;
      color: #495057;
      line-height: 24px;
    }
  }
}
</style>
